module.exports = __webpack_public_path__ + "static/img/saierdafengmian.ba96482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/life/saierdafengmian.jpg
// module id = zYR5
// module chunks = 0